import { OktaAuthOptions } from '@okta/okta-auth-js'
import { z } from 'zod'

import { ApiConfig } from '@lib/rest-web'

export interface Environment {
  production: boolean
  misc: {
    salesEmailAddress: string
  }
  rum:
    | undefined
    | {
        endpoint: string | undefined
        appId: string | undefined
        identityPoolId: string | undefined
        appVersion: string | undefined
        appRegion: string | undefined
      }

  api: ApiConfig
  auth: OktaAuthOptions
}

const envSchema = z.object({
  VITE_PORTAL_MISC_SALES_EMAIL_ADDRESS: z.string(),
  VITE_PORTAL_API_BASE_URL: z.string(),
  VITE_PORTAL_RUM_ENDPOINT: z.string().optional(),
  VITE_PORTAL_RUM_APP_ID: z.string().optional(),
  VITE_PORTAL_RUM_IDENTITY_POOL_ID: z.string().optional(),
  VITE_PORTAL_RUM_APP_VERSION: z.string().optional(),
  VITE_PORTAL_RUM_APP_REGION: z.string().optional(),
  VITE_PORTAL_OKTA_ISSUER: z.string(),
  VITE_PORTAL_OKTA_CLIENT_ID: z.string(),
})

const env = envSchema.parse(import.meta.env)

export const environment: Environment = {
  production: import.meta.env.PROD,
  misc: {
    salesEmailAddress: env.VITE_PORTAL_MISC_SALES_EMAIL_ADDRESS,
  },
  api: {
    baseUri: env.VITE_PORTAL_API_BASE_URL,
  },
  rum: env.VITE_PORTAL_RUM_ENDPOINT
    ? {
        endpoint: env.VITE_PORTAL_RUM_ENDPOINT,
        appId: env.VITE_PORTAL_RUM_APP_ID,
        identityPoolId: env.VITE_PORTAL_RUM_IDENTITY_POOL_ID,
        appVersion: env.VITE_PORTAL_RUM_APP_VERSION,
        appRegion: env.VITE_PORTAL_RUM_APP_REGION,
      }
    : undefined,
  auth: {
    issuer: env.VITE_PORTAL_OKTA_ISSUER,
    clientId: env.VITE_PORTAL_OKTA_CLIENT_ID,
    redirectUri: window.location.origin + '/login/callback',
  },
}
